"use client";

import { useEffect } from "react";
import { markCurrency } from "stores/currency/currencySlice";
import { useAppDispatch } from "stores/hooks";
const UsersCurrencyLogic = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const data = localStorage.getItem("whimstay_conversions_v4");
    if (data) {
      const currency = (JSON.parse(data) as {
        code: string;
        rate: number;
        sign: string;
      });
      dispatch(markCurrency({
        expectedCurrencyCode: currency.code
      }));
    } else {
      const MAPPING = {
        "en-gb": "USD",
        "en-GB": "USD"
      };
      const currencyCode = MAPPING[(navigator?.language as keyof typeof MAPPING)]; // checks user's preferred language
      if (currencyCode) {
        dispatch(markCurrency({
          expectedCurrencyCode: currencyCode
        }));
      }
    }
  }, [dispatch]);
  return null;
};
export default UsersCurrencyLogic;